module.exports = __webpack_public_path__ + "media/images/avatar/20-779e2be02df08e88e7d541282fad718c.svg";